export default {
  hy: {
    title: 'HanClouds IIoT Platform Demonstration',
    meta: {
      keywords: 'HanClouds，LongShine，IIoT，Demonstration',
      description: 'HanClouds IIoT Platform Demonstration'
    },
    power: 'Power',
    fan: 'Fan',
    alarm: 'Alarm',
    share: 'Share',
    scan: 'Scan the following QR code to connect device',//
    copy: 'Copy the following to your friends (this link can only be used once).',//
    copyLink: 'Copy Link',
    spiral: 'Spiral',
    gryo: 'Gryo body',
    deviceOn: 'Device widget switch is on',//
    deviceOff: 'Device widget switch is off',//
    equipmentOn: 'Equipment motor power is on',//
    equipmentOff: 'Equipment motor power is off',//
    productsMaximum: 'The number of user products has reached the maximum and the demo product cannot be created.',//
    linkCopied: 'Share link copied',
    notSupport: 'The browser does not support sharing.',//
    shareUsed: 'The current sharing connection has been used.',//
    connectionBroken: 'The connection is broken. To continue using it, please refresh.',
    offline: 'Equipment disconnected',
    online: 'Equipment connected',
    networkNot: 'Poor network reception',
    noPushInfo: 'No push information is available',
    dataF: 'Subscription data failed, trying to resubscribe.',
    lost: 'Lost connection, trying to resubscribe.',
    reconnect: 'The current environmental network is poor and is trying to reconnect.'
  },
  acc: {
    point: 'Accelerator data point',
    time: 'Tme',
    speed: 'Speed'
  },
  gyroscope: {
    point: 'Gyro data points',
    time: 'Time',
  },
  miss: {
    notExist: 'Sorry! The page you visited does not exist.',
    disconnected: 'The device has been disconnected!'
  },
  mobile: {
    share: 'Share',
    linkSucceeded: 'Device link succeeded',
    linkFailed: 'Device link failed',
    power: 'Power',
    fan: 'Fan',
    tips: 'Operation tips',
    powerSwitch: 'Turn on the power switch and receive the data, otherwise the data will not be pushed',
    rotate: 'Rotating to analog gyroscope data',
    transverse: 'Transverse acceleration of mobile devices to simulate accelerators',
    click: 'Click the alarm button to test the command releasing',
    open: 'Open multiple screens, data can be displayed synchronously',
    qr: 'QR code has been used',
    devicemotion: 'This device does not support devicemotion events.',
    deviceorientatio: 'This device does not support deviceorientatio events.',
    rescan: 'The current environment network is poor, please rescan the QR code.'
  },
  notFound: 'Sorry! The page you visited does not exist.',
  log: 'Operation log',
  tips: {
    title: 'Operation tips',
    m1: '1、Turn on the power switch and receive the data，',
    m2: 'otherwise the data will not be pushed；',
    m3: '2、Rotating to analog gyroscope data；',
    m4: '3、Transverse acceleration of mobile devices to simulate accelerators；',
    m5: '4、Click the alarm button to test the command releasing；',
    m6: '5、Open multiple screens, data can be displayed synchronously；'
  },
  part: {
    m1: 'Device',
    m2: 'Type',
    m3: 'Material',
    m4: 'Feature：Suitable for cutting steel alloy material below 30 degrees',
    m5: '割，可加工30度以下的金',
    m6: '属材，切割硬度强。',
  },
  modelMixin: 'Model failed to load, please refresh and try again.',
  close: 'Close'
};



// WEBPACK FOOTER //
// ./src/i18n/langs/platform/platform.en.js